import { useViewerDateFnsLocale } from "@/lib/translator";
import capitalize from "@/utils/capitalize";
import { format, formatDistanceToNow } from "date-fns";
import { HOUR_MS } from "@/lib/utils/date.ts";

export default function useFormattedDate(timestamp: number) {
  const locale = useViewerDateFnsLocale();
  const date = new Date(timestamp);
  const formattedDate = capitalize(format(date, "PPp", { locale }));
  const relativeDate = capitalize(
    formatDistanceToNow(date, { addSuffix: true, locale }),
  );

  const now = new Date();
  const diffInHours = (now.getTime() - date.getTime()) / HOUR_MS;

  const humanDate = diffInHours < 3 ? relativeDate : formattedDate;

  return {
    humanDate,
    relativeDate,
    formattedDate,
    timestamp,
    date,
  };
}
